import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import Orb from "./Orb";
import { useTranslation } from "react-i18next";

// Hero slide data
const heroData = [
  {
    key: "book-kembar",
    image: "/assets/images/hero-list-kembar.svg",
  },
  {
    key: "book-reja",
    image: "/assets/images/hero-list-reja.svg",
  },
  {
    key: "book-bira",
    image: "/assets/images/hero-list-bira.svg",
  },
  {
    key: "book-cimi",
    image: "/assets/images/hero-list-cimi.svg",
  },
  {
    key: "book-gani",
    image: "/assets/images/hero-list-gani.svg",
  },
];

const HeroList = () => {
  const { t } = useTranslation();
  return (
    <section className="hero-list py-5" style={{ position: "relative" }}>
      <Orb color="rgb(139, 210, 211)" top="-40vh" right="-50vh" />
      <Orb color="rgb(243, 143, 143)" bottom="-30vh" left="-50vh" />

      <Container>
        <h2 className="text-center mb-5 section-title">{t("hero-list-title")}</h2>
        <Row className="justify-content-center">
          {heroData.map((item) => (
            <Col md={6} lg={4} className="text-center hero-item" key={item.key}>
              <Card className="border-0 h-100">
                <Card.Img
                  variant="top"
                  src={item.image}
                  alt={item.title}
                  style={{
                    width: "auto",
                    margin: "auto", // Center the image if it’s smaller than the container
                  }}
                />
                <Card.Body>
                  <Card.Title className="subsection-title color-blue">{t(`${item.key}.title`)}</Card.Title>
                  <Card.Text>{t(`${item.key}.desc2`)}</Card.Text>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default HeroList;
